import React from 'react';
import styled from 'styled-components';

const StyledLoading = styled.div`
  display: inline-block;
  position: relative;
  left: -20px;
  top: 100px;
  width: 64px;
  height: 64px;
  margin: auto;
  &:after {
    content: ' ';
    display: block;
    border-radius: 50%;
    width: 0;
    height: 0;
    margin: 6px;
    box-sizing: border-box;
    border: 49px solid grey;
    border-color: rgba(16, 173, 237, 0.7) transparent rgba(237, 51, 48, 0.7)
      transparent;
    animation: lds-hourglass 1.2s infinite;
  }
  @keyframes lds-hourglass {
    0% {
      transform: rotate(0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
      transform: rotate(900deg);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
      transform: rotate(1800deg);
    }
  }
`;

const LoadingIndicator = props => <StyledLoading />;

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/UI/LoadingIndicator/LoadingIndicator.js